"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.FEATURE_TYPES = exports.FEATURE_COLLECTION_USER = exports.FEATURE_COLLECTION_NAMES = exports.FEATURE_COLLECTION_ENTITLEMENT = exports.FEATURE_COLLECTION_DEVELOPER = exports.DEVICE_EVENT_REGISTRATION_SUCCESS = exports.DEVICE_EVENTS = exports.CISCO_DEVICE_URL = void 0;
// Feature constants.
var FEATURE_COLLECTION_DEVELOPER = 'developer';
exports.FEATURE_COLLECTION_DEVELOPER = FEATURE_COLLECTION_DEVELOPER;
var FEATURE_COLLECTION_ENTITLEMENT = 'entitlement';
exports.FEATURE_COLLECTION_ENTITLEMENT = FEATURE_COLLECTION_ENTITLEMENT;
var FEATURE_COLLECTION_USER = 'user';
exports.FEATURE_COLLECTION_USER = FEATURE_COLLECTION_USER;
var CISCO_DEVICE_URL = 'cisco-device-url';
exports.CISCO_DEVICE_URL = CISCO_DEVICE_URL;
var FEATURE_COLLECTION_NAMES = [FEATURE_COLLECTION_DEVELOPER, FEATURE_COLLECTION_ENTITLEMENT, FEATURE_COLLECTION_USER];
exports.FEATURE_COLLECTION_NAMES = FEATURE_COLLECTION_NAMES;
var FEATURE_TYPES = {
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  STRING: 'string'
};

// Device constants.
exports.FEATURE_TYPES = FEATURE_TYPES;
var DEVICE_EVENT_REGISTRATION_SUCCESS = 'registration:success';
exports.DEVICE_EVENT_REGISTRATION_SUCCESS = DEVICE_EVENT_REGISTRATION_SUCCESS;
var DEVICE_EVENTS = [DEVICE_EVENT_REGISTRATION_SUCCESS];
exports.DEVICE_EVENTS = DEVICE_EVENTS;
//# sourceMappingURL=constants.js.map
